// @ts-nocheck
import React from 'react';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import KwPanel from '../../../common/KwPanel';

import { deleteKeyPoolNotification } from '../../../../actions/keyPoolNotificationActions';
import { toast } from 'react-toastify';
import Button from '../../../common/Button';
import ConfirmationHeader from '../../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';

function DeleteKeyPoolNotification({ done, id, cancel }) {
  const { t } = useTranslation();
  const handleDelete = () => {
    deleteKeyPoolNotification(id)
      .then(() => {
        toast.success(t('Key pool notification successfully deleted'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to delete key pool notification'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Delete confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <Button
          className="btn btn-danger me-2"
          onClick={handleDelete}
          text={t('Yes, delete the key pool notification')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}


export default DeleteKeyPoolNotification;
